// extracted by mini-css-extract-plugin
export var bodyRow = "_gs-d";
export var cardColumns = "_gs-e";
export var ellipsesOverflow = "_gs-2";
export var flatBottomCorners = "_gs-3";
export var flatTopCorners = "_gs-4";
export var headerActionsDropdown = "_gs-f";
export var headerBottomRow = "_gs-c";
export var headerTopRow = "_gs-b";
export var orderDetailsWrapper = "_gs-0";
export var orderInfoContainer = "_gs-1";
export var productDetails = "_gs-9";
export var productImage = "_gs-5";
export var responsiveTable = "_gs-8";
export var shipmentContainer = "_gs-a";
export var tableBottomLeft = "_gs-6";
export var tableBottomRight = "_gs-7";